(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cozybead-bead-sets"] && !Shopify.designMode) return;
  try {
    
  function initBeadCatalog(root){
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    if(!root.hasAttribute('data-legacy'))return;
    const tabs=[...root.querySelectorAll('[data-size-choice]')];
    const activate=()=>{
      const size=new URL(location.href).searchParams.get('size')==='mini'?'mini':'midi';
      root.dataset.sizeActive=size;
      tabs.forEach(tab=>{
        if(tab.dataset.sizeChoice===size)tab.setAttribute('aria-current','page');
        else tab.removeAttribute('aria-current');
      });
      const refill=root.querySelector('[data-refill-link]');
      if(refill){
        const refillUrl=new URL(refill.href);
        refillUrl.searchParams.set('size',size);
        refill.href=refillUrl.pathname+refillUrl.search;
      }
    };
    tabs.forEach(tab=>tab.addEventListener('click',event=>{
      event.preventDefault();
      const url=new URL(location.href);
      url.searchParams.set('view','bead-sets');
      url.searchParams.set('size',tab.dataset.sizeChoice);
      history.pushState(null,'',url);
      activate();
    }));
    window.addEventListener('popstate',activate);
    activate();
  }
  document.querySelectorAll('[data-bead-catalog]').forEach(initBeadCatalog);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-bead-catalog]').forEach(initBeadCatalog));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cozybead-homepage-v3"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cozybead-hero')) {
    customElements.define('cozybead-hero', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.index = 0;
        this.startX = null;
        this.pointerId = null;
        this.startY = null;
        this.didDrag = false;
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1));
        this.addEventListener('dragstart', (event) => event.preventDefault());
        this.addEventListener('pointerdown', (event) => this.startDrag(event));
        this.addEventListener('pointermove', (event) => this.moveDrag(event));
        this.addEventListener('pointerup', (event) => this.endDrag(event));
        this.addEventListener('pointercancel', (event) => this.endDrag(event));
        this.addEventListener('click', (event) => {
          if (!this.didDrag) return;
          event.preventDefault();
          event.stopPropagation();
          this.didDrag = false;
        }, true);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.show(this.index - 1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.show(this.index + 1);
          }
        });
      }
      startDrag(event) {
        if (!event.isPrimary || event.button > 0) return;
        this.didDrag = false;
        if (event.target.closest('button, .cb-home__button')) return;
        this.startX = event.clientX;
        this.startY = event.clientY;
        this.pointerId = event.pointerId;
        this.didDrag = false;

      }
      moveDrag(event) {
        if (this.startX === null || event.pointerId !== this.pointerId) return;
        const delta = event.clientX - this.startX;
        if (!this.didDrag) {
          const deltaY = event.clientY - this.startY;
          if (Math.abs(deltaY) > Math.abs(delta) && Math.abs(deltaY) > 10) {
            this.startX = null;
            this.pointerId = null;
            return;
          }
          if (Math.abs(delta) <= 10) return;
          this.didDrag = true;
          this.setPointerCapture(event.pointerId);
          this.dataset.dragging = 'true';
        }
        this.style.setProperty('--cb-hero-drag', `${delta * .78}px`);
      }
      endDrag(event) {
        if (this.startX === null || event.pointerId !== this.pointerId) return;
        const delta = event.clientX - this.startX;
        if (this.hasPointerCapture?.(event.pointerId)) {
          this.releasePointerCapture(event.pointerId);
        }
        this.startX = null;
        this.pointerId = null;
        delete this.dataset.dragging;
        this.style.removeProperty('--cb-hero-drag');
        if (event.type === 'pointercancel') this.didDrag = false;
        if (event.type !== 'pointercancel' && Math.abs(delta) > 55) this.show(this.index + (delta < 0 ? 1 : -1));
      }
      show(next) {
        this.index = (next + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.dataset.active = String(active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
      }
    });
  }

  if (!customElements.get('cozybead-gallery')) {
    customElements.define('cozybead-gallery', class extends HTMLElement {
      connectedCallback() {
        this.cards = [...this.querySelectorAll('[data-gallery-card]')];
        this.count = this.querySelector('[data-gallery-count]');
        this.index = 0;
        this.startX = null;
        this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.show(this.index + 1));
        this.cards.forEach((card, index) => card.addEventListener('click', () => this.show(index)));
        this.addEventListener('touchstart', (event) => { this.startX = event.touches[0]?.clientX ?? null; }, { passive: true });
        this.addEventListener('touchend', (event) => {
          if (this.startX === null) return;
          const delta = (event.changedTouches[0]?.clientX ?? this.startX) - this.startX;
          if (Math.abs(delta) > 45) this.show(this.index + (delta < 0 ? 1 : -1));
          this.startX = null;
        }, { passive: true });
        this.show(0);
      }
      show(next) {
        this.index = (next + this.cards.length) % this.cards.length;
        this.cards.forEach((card, index) => {
          let offset = index - this.index;
          if (offset > this.cards.length / 2) offset -= this.cards.length;
          if (offset < -this.cards.length / 2) offset += this.cards.length;
          const distance = Math.abs(offset);
          const active = index === this.index;
          card.dataset.active = String(active);
          card.setAttribute('aria-selected', String(active));
          card.style.setProperty('--cb-x', `${offset * 13}%`);
          card.style.setProperty('--cb-y', `${distance * 18}px`);
          card.style.setProperty('--cb-r', `${offset * 3.2}deg`);
          card.style.setProperty('--cb-s', String(Math.max(.72, 1 - distance * .055)));
          card.style.zIndex = String(this.cards.length - distance);
          card.style.opacity = distance > 3 ? '.72' : '1';
        });
        if (this.count) this.count.textContent = `${this.index + 1} / ${this.cards.length}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cozybead-info-page"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.cb-learn__play');
    if (!button) return;
    const video = button.parentElement.querySelector('video');
    if (!video) return;
    document.querySelectorAll('.cb-learn video').forEach((other) => {
      if (other !== video) other.pause();
    });
    button.hidden = true;
    video.play().catch(() => { button.hidden = false; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cozybead-product-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.cb-howto__play');
    if (!button) return;
    const video = button.parentElement.querySelector('video');
    if (!video) return;
    button.hidden = true;
    video.play().catch(() => { button.hidden = false; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
